<kgrid
  #grid
  [label]="title"
  [reportName]="name"
  [pathPreFix]="pathPreFix"
  [areaName]="areaName"
  [filters]="filters"
  [filterText]="filterText"
  [columns]="columns"
  [isModal]="isModal"
  [isMulti]="selective"
  [groupable]="groupable"
  [dataList]="customDataList"
  [onlyDefaultSortKey]="onlyDefaultSortKey"
  [unSortableFilterable]="unSortableFilterable"
  [filtering]="filtering"
  [defaultSortKey]="defaultSortKey"
  defaultSortKeyKind="asc"
  [aggregatesColumnName]="aggregatesColumnName"
  [actions]="actions"
  [actionTregger]="actionTregger"
  [disableOnDoubleClick]="true"
  (onDoubleClick)="onDoubleClick($event)"
  (onRowsSelected)="applyFilter($event)"
  (onRowSelected)="applyFilter($event)"
  [name]="key">
</kgrid>
